import ReactGA from "react-ga4";

export const initAnalytics = (trackingId: string) => {
  ReactGA.initialize(trackingId);
};

export const logPageView = (pagePath: string) => {
  ReactGA.send({ hitType: "pageview", page: pagePath });
};

export const logEvent = (action: string, category?: string, label?: string) => {
  ReactGA.event({
    action,
    category: category || "",
    label: label || "",
  });
};
